<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      arr: []
    }
  },
  mounted () {
    for (var keys in this.commonData) {
      this.readItems(keys)
    }
    // 测试用
    this.readItemList()
  },
  methods: {
    /**
     * 页头、页脚公用信息查询
     */
    readItems (key) {
      this.get({
        url: 'configFind',
        data: {
          key: key
        }
      }, (r) => {
        if (r.code) {
          this.$store.commit('setFooterData', {
            key: key,
            value: r.data
          })
        } else {
          this.error(r.msg)
        }
      })
    },
    /**
     * 页头、页脚公用信息查询
     */
    readItemList (key) {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          this.arr = JSON.parse(r.data.value)
        }
      })
    },
    /*
    * 更新配置
    */
    updateConfig (item) {
      this.put({
        url: 'configUpdate',
        data: {
          id: item.id,
          value: JSON.stringify(this.arr)
        }
      }, r => {
        console.log(r)
      })
    }
  }
}
</script>

<style lang="less" src="./utils/main.less"></style>
<style lang="less" src="./utils/icon.css"></style>
<style>
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  #app {
    width: 375px;
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  #app {
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue